<ng-container *ngIf="hasError()">
  <small *ngFor="let err of errorMessages" class="text-red-500">{{err}}</small>
</ng-container>
